module.exports = new __parcel__URL__("signature.685f05f5.svg").toString();